import { createAction } from 'redux-actions'

export const setTriggerUsersFetch = createAction('SET_TRIGGER_USERS_FETCH')
